import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import i18next from 'i18next';
import { useU2000LogicalUnitContext } from '../u2000Core/context/logicalUnit/U2000LogicalUnitContext';

export const NS = 'u2106';

export const U2106ROLES = {
  CHANGEPASSWORD: 'U2106:CHANGEPASSWORD',
  READ: 'U2106:READ',
  EDIT: 'U2106:EDIT',
  MFA: 'U2106:MFA',
} as const;
export type U2106ROLES = (typeof U2106ROLES)[keyof typeof U2106ROLES];

/**
 * Shell U2106 « Mon compte » — pas d'initLU.
 * Titre dynamique selon la route (profil / mot de passe).
 */
const U2106: React.FC = () => {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [i18nReady, setI18nReady] = useState(false);
  const { setLogicalUnitTitle, setLogicalUnitBreadcrumb } = useU2000LogicalUnitContext();

  useEffect(() => {
    i18next.loadNamespaces(['u2106'], (err) => {
      if (err) {
        console.error('Error loading namespace:', err);
        return;
      }
      setI18nReady(true);
    });
  }, [i18n]);

  useEffect(() => {
    if (!i18nReady) return;

    const path = location.pathname;
    let titleKey = 'myProfile.title';
    if (path.includes('/password')) {
      titleKey = 'changePassword.title';
    } else if (path.includes('/ai-usage')) {
      titleKey = 'myAiUsage.title';
    }

    setLogicalUnitTitle(t(titleKey, { ns: NS }));
    setLogicalUnitBreadcrumb([]);
    return () => {
      setLogicalUnitTitle('');
      setLogicalUnitBreadcrumb([]);
    };
  }, [i18nReady, t, location.pathname, setLogicalUnitTitle, setLogicalUnitBreadcrumb]);

  if (!i18nReady) {
    return null;
  }

  return <Outlet />;
};

export default U2106;
